<template>
  <nav class="navbar bg-custom-2 mt-5 mb-0">
    <div class="float-left"> <button
        @click="socialClick('https://www.facebook.com/NegativeMuzikDreamer')"
        class="btn btn-social-icon btn-facebook btn-rounded"
      ><i class="fa fa-facebook"></i></button> <button
        @click="socialClick('https://www.youtube.com/channel/UCXl2Y3MzHrCU7U7rnItrYlg')"
        class="btn btn-social-icon btn-youtube btn-rounded"
      ><i class="fa fa-youtube"></i></button>
      <button
        @click="socialClick('https://www.instagram.com/ankur.luthra')"
        class="btn btn-social-icon btn-instagram btn-rounded"
      ><i class="fa fa-instagram"></i></button>
      <button
        @click="socialClick('https://twitter.com/AnkurLuthra17')"
        class="btn btn-social-icon btn-twitter btn-rounded"
      ><i class="fa fa-twitter"></i></button>
      <button
        @click="socialClick('https://www.linkedin.com/in/ankurluthra17/')"
        class="btn btn-social-icon btn-linkedin btn-rounded"
      ><i class="fa fa-linkedin"></i></button>
      <button
        @click="socialClick('https://www.smule.com/MuzikDreamer')"
        class="btn btn-social-icon btn-linkedin btn-rounded"
      ><i class="fa fa-music"></i></button>
      <!-- <button
        type="button"
        class="btn btn-social-icon btn-dribbble btn-rounded"
      ><i class="fa fa-dribbble"></i></button>  -->
    </div>
    <span class="float-right">
      <a
        class="text-dark font-weight-bold"
        href="#"
      > muzikdreamer.com &copy;{{ new Date().getFullYear() }}
      </a>
    </span>
  </nav>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    socialClick(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bg-custom-2 {
  /* background-image: linear-gradient(15deg, #23d8c3 0%, #6dc557 100%) !important; */
  background-color: #bdd8fe;
  background-image: linear-gradient(315deg, #bdd8fe 0%, #e186b4 74%) !important;
}
</style>
